<div class="card">
  <div class="card-header p-2">
    @if (hasMiUser() && hasArpUser()) {
      <button class="btn btn-primary btn-floating btn-sm float-end" routerLink="/arp/woche">
        <i class="fal fa-calendar-alt" aria-hidden="true"></i>
      </button>
      <button class="btn btn-primary btn-floating btn-sm float-end me-1" [routerLink]="['/arp/tag', currentDatum()]">
        <i class="fal fa-calendar" aria-hidden="true"></i>
      </button>
      <button
        class="btn btn-primary btn-floating btn-sm float-end me-1"
        [routerLink]="['/arp/statistik', currentJahr()]"
      >
        <i class="fal fa-chart-bar" aria-hidden="true"></i>
      </button>
    }
    <h4 class="card-title mb-0 mt-1">
      <i class="fal fa-clock" aria-hidden="true"></i>
      Rapport
    </h4>
  </div>
  @if (!hasMiUser() || !hasArpUser()) {
    <div class="card-body b2-card pe-2">
      <p class="card-text">
        @if (!hasMiUser()) {
          <span>
            Rapportierung kann nicht verwendet werden. Dem Benutzer wurde im Bauplus kein Mitarbeiter zugewiesen.
          </span>
        }
        @if (hasMiUser() && !hasArpUser()) {
          <span>Rapportierung kann nicht verwendet werden. Es gibt im Bauplus keine Rapportierung zum Benutzer.</span>
        }
      </p>
    </div>
  }
  @if (hasMiUser() && hasArpUser()) {
    <div class="card-body b2-card pe-2 hand" routerLink="/arp/woche">
      <div class="card-text">{{ miName() }}</div>
    </div>
  }
</div>
